import { computed, type Ref, ref, watch } from 'vue'
import { useStore } from 'vuex'

import { localStorageService } from '@/lib/services/localStorage.services'

export const useShouldDisableMoveToDoneWarningPopup = (): {
  shouldDisableMoveToDoneWarningPopup: Ref<boolean | null>
} => {
  const store = useStore()
  const userId = computed(() => store.getters['user/userId'])
  const localStorageKey = localStorageService.composeKey(
    'shouldDisableMoveToDoneWarningPopup',
    userId.value,
  )
  const shouldDisableMoveToDoneWarningPopup = ref(
    localStorageService.getItem<boolean>(localStorageKey),
  )
  watch(shouldDisableMoveToDoneWarningPopup, (newVal) => {
    localStorageService.setItem(localStorageKey, newVal)
  })

  return {
    shouldDisableMoveToDoneWarningPopup,
  }
}
